import { prepareUrl } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class FetchAllUserGiftingAddresses {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * FetchAllUserGiftingAddresses constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Handle fetching the user's gifting address book.
     *
     * @param {number} userId
     *
     * @returns {Promise}
     */
    handle(userId) {
        let apiUrl = prepareUrl(ApiEndpoints['gifting-addresses.index'], [userId]);

        return this.apiService.get(apiUrl);
    }
}
